import { Icon } from '@tkww/orion-web-ds-graphic';
import React from 'react';
import Styles from './styles.scss';

interface CouplesUsuallySpendEmptyDetailsProps {
	couplesUsuallySpend: string | null;
}

export const CouplesUsuallySpendEmptyDetails = ({
	couplesUsuallySpend,
}: CouplesUsuallySpendEmptyDetailsProps) => {
	return (
		<div className={Styles.usuallySpend}>
			<Icon
				name="couple"
				size="md"
				data-testid="cus-guest-couple"
				aria-label="Couple"
			/>
			<span>Couples usually spend {couplesUsuallySpend}</span>
		</div>
	);
};
